import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 italic text-center">(popola kanto)</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Fluas rivereto <br/>
        Sub la ponto ŝtona, <br/>
        Sur la pont’ – ŝafeto <br/>
        Kun vosteto bona.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Kiu ĝin necesas? <br/>
        Kiu ĝin bezonas? <br/>
        Neniu necesas, <br/>
        Neniu bezonas.
      </p>

      <p class="poem-block mb-3">
        Seka rivereto, <br/>
        Falis ponto ŝtona, <br/>
        Mortis la ŝafeto, <br/>
        Vosto jam ne bona.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
        Vivas rivereto, <br/>
        Pont’ restaris ŝtona, <br/>
        Ree la ŝafeto <br/>
        Voston svingas, bona.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ŝafeto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['56lbpZwua24'],
    itemTranslator: translator.esp
  }
}

export default item;